<template>
	<div class="register">
		<Card class="register__card">
			<template #header>
				<div class="register__logo-container">
					<img
						alt="codecannon logo"
						class="register__logo"
						src="@/assets/logo.svg" /></div
			></template>
			<template #title>Register</template>
			<template #content>
				<form @submit.prevent="submit()">
					<FormInput
						label="Email"
						:error-message="formErrors?.email?.[0]">
						<InputText
							v-model="form.email"
							@keyup.enter="submit" />
					</FormInput>
					<FormInput
						label="Password"
						:error-message="formErrors?.password?.[0]">
						<InputText
							v-model="form.password"
							type="password"
							@keyup.enter="submit" />
					</FormInput>
					<FormInput
						label="Password Confirmation"
						:error-message="formErrors?.password_confirmation?.[0]">
						<InputText
							v-model="form.password_confirmation"
							type="password"
							@keyup.enter="submit" />
					</FormInput>
					<FormInput :error-message="formErrors?.accepts_toc?.[0]">
						<template #prepend-input>
							<Checkbox
								id="agree-to-terms"
								v-model="form.accepts_toc"
								binary />
						</template>
						<template #label>
							<label
								class="login__toc-label"
								for="agree-to-terms">
								I agree with the
								<b>
									<router-link :to="{ name: 'terms-of-service' }">Terms of Service</router-link></b
								>
								and
								<b>
									<router-link :to="{ name: 'privacy-policy' }">Privacy Policy</router-link></b
								></label
							>
						</template>
					</FormInput>
					<Button
						class="register__register-button"
						label="Register"
						type="submit"
						:loading />
					<Divider />
					<Button
						label="Login"
						outlined
						:disabled="loading"
						@click="router.push({ name: 'login' })" />
				</form>
			</template>
		</Card>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useAuthStore } from '@/stores/Auth'
import { useRouter } from 'vue-router'
import Button from 'primevue/button'
import Card from 'primevue/card'
import InputText from 'primevue/inputtext'
import Divider from 'primevue/divider'
import Checkbox from 'primevue/checkbox'
import FormInput from '@/components/FormInput.vue'

const form = ref({
	email: '',
	password: '',
	password_confirmation: '',
	accepts_toc: false,
})
const formErrors = ref<{
	email?: string[]
	password?: string[]
	password_confirmation?: string[]
	accepts_toc?: string[]
} | null>(null)
const loading = ref(false)

const router = useRouter()
const auth = useAuthStore()

async function submit() {
	loading.value = true
	try {
		await auth.register(form.value)
		await auth.getUser()
		router.push('/')
	} catch (error: any) {
		if (error.response?.status === 422) {
			formErrors.value = error.response?.data?.errors
		}
	} finally {
		loading.value = false
	}
}
</script>

<style scoped lang="scss">
.register {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100vh;
	width: 100%;

	.register__card {
		width: 500px;
		overflow: hidden;

		&:deep(.p-card-content) {
			form {
				gap: 10px;
				display: flex;
				flex-direction: column;

				.register__register-button {
					margin-top: 16px;
				}
			}
		}
	}
	.register__logo {
		padding-left: 45px;
		padding-right: 45px;
		padding-bottom: 20px;
		padding-top: 20px;
		background: #eeff01;
		margin: auto;
		display: block;
	}
}
</style>
